import { ISendEmailPayload, ISendEmailSuccessResponse, ISendEmailErrorResponse } from '@types';
import { postSendEmail } from '@api';
import { useMutation, UseMutationResult } from '@tanstack/react-query';

interface Props {
  onSuccess?: (res: ISendEmailSuccessResponse) => void;
  onError?: (err: ISendEmailErrorResponse) => void;
}

export const usePostSendEmail = ({
  onSuccess,
  onError,
}: Props): UseMutationResult<
  ISendEmailSuccessResponse,
  ISendEmailErrorResponse,
  ISendEmailPayload,
  unknown
> => {
  const mutation = useMutation((props: ISendEmailPayload) => postSendEmail(props), {
    onSuccess,
    onError,
  });

  return mutation;
};

export default usePostSendEmail;
